var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSupported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 972.72 1987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f859c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.68,813.63l-96.06,257.24c-45.69,91.77-180.22,44.04-159.46-57.36,52.26-126.42,89.53-263.08,142.17-388.78,38.35-91.57,105.76-155.29,209.14-162.54,73.49-5.15,205.19-6.55,277.42.68,78.46,7.85,153.64,65.41,187.1,135.57,61.48,128.93,97.26,288.98,154.08,421.78,10.97,106.58-121.07,139.54-165,42.5l-91.95-249.09v1084.4c0,12.26-14.12,40.8-22.37,51.15-59.86,75.12-175.04,29.79-177.91-63.25l.35-637.52c-4.39-33.72-52.17-34.36-57.6,0l.35,641.6c-4.53,87.11-110.91,131.15-171.79,65.31-10.24-11.07-28.48-43.25-28.48-57.29V813.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.91,1.98c282.3-34.15,313.18,383.6,55.54,410.88C236.55,442.07,201.7,32.86,456.91,1.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSupported);
export default __webpack_public_path__ + "static/media/Not Supported.faf8d984addc9521e4fc510012fafb5f.svg";
export { ForwardRef as ReactComponent };